<template>
  <div class="modal" v-if="downloadModalVisible" @click="hideModal">
    <div @click.stop class="modal-content">
      <div style="padding: 20px;">
        <div class="m-header">
          <h3 class="m-header-text">Download summary</h3>
          <img class="close-modal-img" src="/images/close.png" @click="hideModal"/>
        </div>
        <div class="divider"></div>
        <div class="additional-text mt-15">
          You can add your personal comments here and they will be automatically integrated into the report.
        </div>
        <textarea class="feedback-text" placeholder="Add your comment here..." v-model="comment"></textarea>
        <div class="divider"></div>
        <div class="actions-btns">
          <simple-button type="secondary" @click.native="hideModal">
            Cancel
          </simple-button>
          <simple-button style="margin-left: 20px;" type="primary" @click.native="downloadSummary">
            Download
          </simple-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import SimpleButton from './SimpleButton.vue';
import { Answer } from "@/entities/questionaire/answers/Answer";
import { HttpHandler } from "@/http/HttpHandler";
import { Treatment } from "@/entities/Treatment";
import { QuestionnaireResult } from "@/entities/questionaire/QuestionnaireResult";
import { SelfcheckReport } from "@/entities/SelfcheckReport";
import store from "@/store/index";

@Component({
  name: 'DownloadReportModal',
  components: {
    SimpleButton,
  }
})
export default class DownloadReportModal extends Vue {
  @Prop()
  downloadModalVisible!: Boolean;

  @Prop()
  answers!: Answer[];

  @Prop()
  result!: QuestionnaireResult;

  @Prop()
  treatmentHistory!: Treatment[] | null;

  @Prop()
  branchId!: number;

  @Prop()
  excludedRecommendations!: {
    id: number;
    name: string;
    approvalPercentage: number;
  }[];

  comment: string = '';

  hideModal() {
    this.$emit('update:downloadModalVisible', false);
    this.comment = '';
  }

  async downloadSummary() {
    const httpHandler = new HttpHandler(store);
    await httpHandler.downloadAssessmentResult(
      new SelfcheckReport(
        this.branchId,
        false,
        this.answers,
        this.treatmentHistory,
        this.excludedRecommendations,
        this.comment
      )
    );
    this.comment = '';
    this.hideModal();
  }
}
</script>

<style lang="scss" scoped>
.modal {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: flex;
}
  
.modal-content {
  margin: auto;
  background: white;
  border-radius: 12px;
  min-height: 183px;
  min-width: 300px;
  max-width: 525px;
  border: 1px solid #FFFFFF;
}

.m-header {
  display: flex;
  justify-content: space-between;
}

.m-header-text {
  font-size: 18px;
  font-weight: 600;
}

.close-modal-img {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.feedback-text {
  resize: none;
  max-width: 484px;
  height: 128px;
  border: 1px solid #E2E4EB;
  border-radius: 8px;
  padding: 10px;
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
}

.feedback-text:focus {
  outline: none;
  border: 1px solid #8D939E;
}

.additional-text {
  font-size: 14px;
  font-weight: 400;
}

.divider {
  height: 1px;
  max-width: 485px;
  background-color: #DAE0EA;
}

.actions-btns {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}

.mt-15 {
  margin-top: 15px;
}
</style>
